/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostForAzureMaccCommitmentConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostForAzureMaccCommitmentConfiguration");
    }

    getFixupPrototypeFunction() { return CostForAzureMaccCommitmentConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostForAzureMaccCommitmentConfiguration>): CostForAzureMaccCommitmentConfiguration {
        let obj = Object.assign(new CostForAzureMaccCommitmentConfiguration(), model);
        CostForAzureMaccCommitmentConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostForAzureMaccCommitmentConfiguration>): CostForAzureMaccCommitmentConfiguration {
        if (!model) return null;
        return CostForAzureMaccCommitmentConfiguration.newInstance(<CostForAzureMaccCommitmentConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostForAzureMaccCommitmentConfiguration) {
        if (!obj) return;

        models.CostForAzureMaccCommitmentConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostForAzureMaccCommitmentConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostForAzureMaccCommitmentConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
